import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { NavHeaderService } from 'src/app/shared/services/nav-header.service';
import { NavService } from './../nav.service';
import { UserDetailService } from 'src/app/shared/services/user-detail.service';
import { AppState } from 'src/app/state/app.reducer';
import { AuthActions } from '../../auth/state/action-typs';
import { ResetDashboardStateAction } from '../../dashboard/state/action-types';
import { Menu } from 'src/app/types';
import { MenuComponent } from '../menu/menu.component';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MenuComponent],
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
})
export class SideNavComponent implements OnInit, OnDestroy {
  protected readonly navService = inject(NavService);
  protected readonly navHeader = inject(NavHeaderService);
  protected readonly store = inject(Store<AppState>);
  protected readonly userDetailService = inject(UserDetailService);
  protected readonly destroy$ = new Subject<void>();

  readonly opened = signal(false);
  readonly parentClubLogo = signal<string>('');

  ngOnInit(): void {
    this.navService.isOpenedObs$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => {
      this.opened.set(isOpen);
    });
    this.userDetailService.loggedOnUserDetails$.pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.parentClubLogo.set(data?.parentClubLogo ?? '');
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  protected toggleLeftNav(menu: Menu): void {
    if (!menu.subMenu) {
      this.opened.update(v => !v);
    }
  }

  protected logout(): void {
    this.navHeader.toggleHeaderVisibility(false);
    this.navService.toggleSideNav(this.opened());
    this.store.dispatch(AuthActions.logout({ authUser: undefined }));
    this.store.dispatch(ResetDashboardStateAction.resetDashBoardState());
  }
}
